import {Component, Input} from '@angular/core';

import {CoreMenuItem} from '@core/types';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;
}
